import { httpGet, httpPost, httpRoute, httpUserId } from '../infrastructure/http/http-decorators';

@httpRoute('/api/premium-tracking')
export abstract class IPremiumTrackingService {
	@httpPost('track-article-view')
	trackArticleView(@httpUserId() userId: string): Promise<void> {
		void userId;
		throw new Error('Not implemented');
	}

	@httpGet('is-article-available')
	isArticleAvailable(@httpUserId() userId: string): Promise<boolean> {
		void userId;
		throw new Error('Not implemented');
	}
}


